import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=6ba326af"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba326af')) {
      api.createRecord('6ba326af', component.options)
    } else {
      api.reload('6ba326af', component.options)
    }
    module.hot.accept("./Changelog.vue?vue&type=template&id=6ba326af", function () {
      api.rerender('6ba326af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/changelog/Changelog.vue"
export default component.exports